import script from "./AdminContacts.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminContacts.vue?vue&type=script&setup=true&lang=js"

import "./AdminContacts.vue?vue&type=style&index=0&id=72f363f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72f363f0"]])

export default __exports__